import cx from 'classnames'
import { FC } from 'react'

import ColumnSectionCard, {
  ColumnSectionCardProps,
} from 'src/components/ColumnSectionCard'
import { Icons } from 'src/components/Icon'
import useMediaQuery from 'src/hooks/useMediaQuery'

import { useTranslation } from 'react-i18next'
import * as SC from './styled'

export type ColumnSectionProps = {
  className?: string
  title: string
  items: Array<ColumnSectionCardProps>
}

const ColumnSection: FC<ColumnSectionProps> = ({ className, title, items }) => {
  const matches = useMediaQuery('(min-width: 960px)')
  const { t } = useTranslation()

  return (
    <SC.ColumnSection className={cx('ColumnSection', className)}>
      {matches && (
        <SC.CrossesIcon
          icon={Icons.crossesSecondary}
          width={135}
          height={106}
        />
      )}
      <SC.Title>{t(title as any)}</SC.Title>
      <SC.ColumnList>
        {items.map((item, index) => (
          <SC.ColumnListItem key={index}>
            <ColumnSectionCard {...item} />
          </SC.ColumnListItem>
        ))}
      </SC.ColumnList>
    </SC.ColumnSection>
  )
}

export default ColumnSection
